var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:_vm.classTooltip},[_c('img',{attrs:{"src":require('@/assets/lib/images/common/icon/q-mark-org.svg'),"alt":"","width":_vm.width}}),_c('span',{class:_vm.classContent,domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }